export default __webpack_public_path__ + "static/media/draw-banner-background-cute-cats-yellow.212bd54a.png";